import { c as t } from "../../_utils/cssr/index.js";
import i from "../common/_common.js";
const {
  fontSize: o,
  fontFamily: e,
  lineHeight: n
} = i, r = t("body", `
 margin: 0;
 font-size: ${o};
 font-family: ${e};
 line-height: ${n};
 -webkit-text-size-adjust: 100%;
 -webkit-tap-highlight-color: transparent;
`, [t("input", `
 font-family: inherit;
 font-size: inherit;
 `)]);
export {
  r as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/_styles/global/index.cssr.js
// module id = 934
// module chunks = 67